export class SearchMedicalReportAuditRequest {
  MedicalReportId?: number;
  EntityId: number;
  FromDate?: Date;
  ToDate?: Date;
  SpecialtyId?: number;
  ServiceId?: number;
  CategoryId?: number;
  OnlyUnclassified: boolean;
  IncludeExported: boolean;
  IncludeNotExported: boolean;
  BillingStatusIds: number[] = [];
  NonBillableReasonIds: number[] = [];
  OnlyRegistered: boolean;
}
